import { render, staticRenderFns } from "./search-template-pattern.vue?vue&type=template&id=164a98ba&scoped=true&"
import script from "./search-template-pattern.vue?vue&type=script&lang=js&"
export * from "./search-template-pattern.vue?vue&type=script&lang=js&"
import style0 from "./search-template-pattern.vue?vue&type=style&index=0&id=164a98ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a98ba",
  null
  
)

export default component.exports